import { z } from "zod";

export const warehouseLocationsFormSchema = z.object({
	shelfSize: z.number().min(0).max(99),
	floorSize: z.number().min(0).max(999),
	axisSize: z.number().min(0).max(999),
});

export type WarehouseLocationsFormSchema = z.infer<typeof warehouseLocationsFormSchema>;
